export default "__VITE_ASSET__90e8bc4e__"